module.exports = __webpack_public_path__ + "static/media/Kunji-Kalathappam.3d0ebe87.jpg";